import { IMonthsRange } from 'main/gql/schoolAgeGroup'
import { ITuitionProgram } from 'main/gql/schoolTuitionProgram'

export function tuitionProgramAgeRange(tuitionProgram: ITuitionProgram): IMonthsRange {
  const { ageMonthsMin: min, ageMonthsMax: max } = tuitionProgram
  return { __typename: 'SchoolAgeGroupRange', min, max }
}
